import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { Button, Card, CardBody, CardHeader, Row, UncontrolledTooltip } from "reactstrap";
import "./MyTable.css";

const options = {
  sortIndicator: true,
  hideSizePerPage: false,
  paginationSize: 3,
  hidePageListOnlyOnePage: false,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
};

export default function PartyDetailsBody({ data, updateDetails, changeFlag, deleteParty }) {
  const cellButton = (cell, row, enumObject, rowIndex) => {
    return (
      <span key={row.id}>
        <div>
          <Button
            className="btn btn-warning"
            id={`view-${rowIndex}`}
            onClick={(e) => updateDetails(row)}
            style={{ marginLeft: "5px" }}
            key={`view-${rowIndex}`}
          >
            <i className="fa fa-eye" />
          </Button>
          <Button
            className="btn btn-danger"
            id={`delete-${rowIndex}`}
            onClick={(e) => deleteParty(row)}
            style={{ marginLeft: "5px" }}
            key={`delete-${rowIndex}`}
          >
            <i className="fa fa-trash" />
          </Button>
        </div>
      </span>
    );
  };


  return (
    <Card>
      <CardHeader className="carheaderSmall">
        <strong>Party Details</strong>
      </CardHeader>
      <CardBody>
        <Row className="justify-content-start">
          <Button
            className="btn btn-warning"
            id="addParty"
            name="addParty"
            onClick={(e) => changeFlag()}
            style={{ marginLeft: "20px", marginBottom: "10px" }}
          >
            Add Party
          </Button>
        </Row>
        <BootstrapTable
          data={data}
          version="4"
          condensed={true}
          striped
          hover
          pagination
          search
          options={options}
          exportCSV
          csvFileName="Party_Details.csv"
        >
          <TableHeaderColumn
            isKey
            dataField="mobileNumber"
            export={false}
            hidden={true}
          >
            ID
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="customerName"
            csvHeader="Customer Name"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            Customer Name
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="beatName"
            csvHeader="Beat Name"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            Beat Name
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="mobileNumber"
            csvHeader="Mobile Number"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            Mobile Number
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="address"
            csvHeader="Address"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            Address
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="city"
            csvHeader="city"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            City
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="pinCode"
            csvHeader="pinCode"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            PinCode
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="gstNumber"
            csvHeader="GST Number"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            GST Number
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="creditLimit"
            csvHeader="Credit Limit"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            Credit Limit
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="active"
            csvHeader="Active"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            Active
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="button"
            dataFormat={cellButton}
            hiddenOnInsert
            export={false}
          >
            Actions
          </TableHeaderColumn>
        </BootstrapTable>
      </CardBody>
    </Card>
  );
}


// WEBPACK FOOTER //
// ./src/components/CustomComponents/PartyDetailsBody.js